import { render } from "./Sport.vue?vue&type=template&id=95efa888&scoped=true"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"

import "./Sport.vue?vue&type=style&index=0&id=95efa888&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95efa888"]])

export default __exports__